import { render, staticRenderFns } from "./PaperPractice.vue?vue&type=template&id=6de0f932&"
import script from "./PaperPractice.vue?vue&type=script&lang=js&"
export * from "./PaperPractice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports